import { render } from "./ToDo.vue?vue&type=template&id=669f327b&scoped=true&ts=true"
import script from "./ToDo.vue?vue&type=script&lang=ts"
export * from "./ToDo.vue?vue&type=script&lang=ts"

import "./ToDo.vue?vue&type=style&index=0&id=669f327b&scoped=true&lang=css"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669f327b"]])

export default __exports__